import { gql } from '@apollo/client';
import { forPaginated } from './common/paginated.graphql';
import { Kit } from '../types/kit/kit';
import { CreateKitInput, DeleteKitInput, UpdateKitInput } from '../types/kit/kit.input';

const kit = gql`
  fragment Kit on Kit {
    id
    version
    companyId
    createdAt
    createdBy
    updatedAt
    updatedBy
    identifier
    templateId
  }
`;

const get = gql`
  query Kits($page: Float) {
    kits(page: $page) {
      data {
        ...Kit
      }
      page
      pageSize
      batchSize
      hasNext
    }
  }
  ${kit}
`;

export interface GetKitsVariables {
  page?: number;
}

export interface GetKitsResponse {
  kits: PaginatedKits;
}

class PaginatedKits extends forPaginated<Kit>() {}

const create = gql`
  mutation CreateKit($kits: [CreateKitInput!]!) {
    createKit(kits: $kits) {
      ...Kit
    }
  }
  ${kit}
`;

export interface CreateKitVariables {
  kits: CreateKitInput[];
}

export interface CreateKitResponse {
  createKit: Kit[];
}

const update = gql`
  mutation UpdateKit($kits: [UpdateKitInput!]!) {
    updateKit(kits: $kits) {
      ...Kit
    }
  }
  ${kit}
`;

export interface UpdateKitVariables {
  kits: UpdateKitInput[];
}

export interface UpdateKitResponse {
  updateKit: Kit[];
}

const remove = gql`
  mutation DeleteKit($kits: [DeleteKitInput!]!) {
    deleteKit(kits: $kits) {
      ...Kit
    }
  }
  ${kit}
`;

export interface DeleteKitVariables {
  kits: DeleteKitInput[];
}

export interface DeleteKitResponse {
  deleteKit: Kit[];
}

export const KitQueries = {
  get,
};

export const KitMutations = {
  create,
  update,
  remove,
};

export const KitFragment = {
  kit: kit,
};
